import { Suspense } from 'react';
import { ApolloProvider } from '@apollo/client';
import { ToastContainer, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import './stylesheets/global.css';
import './styles/index.css';
import { useApollo } from 'lib/apolloClient';
import { AuthProvider, UserProvider } from 'contexts';
import LoadingSpinner from 'components/common/LoadingSpinner';
import { Router } from 'routers';
import { getToken } from 'utils/auth';
import { StyledToast } from 'toolkit/components';

function App() {
  const apolloClient = useApollo(getToken());

  return (
    <>
      <ApolloProvider client={apolloClient}>
        <AuthProvider>
          <UserProvider>
            <Suspense fallback={<LoadingSpinner />}>
              <Router />
            </Suspense>
          </UserProvider>
        </AuthProvider>
      </ApolloProvider>
      <StyledToast>
        <ToastContainer
          icon={false}
          position="top-center"
          pauseOnFocusLoss={false}
          autoClose={5000}
          transition={Zoom}
          hideProgressBar={true}
        />
      </StyledToast>
    </>
  );
}

export default App;
